module.exports = __webpack_public_path__ + "img/heise.a0c069ca.png";